import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { ConfigService } from '@core/services/config.service';
import { environment } from '@environment';
import { I18nModule } from '@i18n/i18n.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { appReducers, metaReducers } from '@redux/app.reducers';
import { LifePlanEffects } from '@redux/effects/life-plan.effects';
import { RecommendedProductsEffects } from '@redux/effects/recommended-products.effects';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { NgxMaskModule } from 'ngx-mask';
import { BuildSpecificsModules } from '../build-specifics/build-specific';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ModalsModule } from './modals/modals.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    HttpClientModule,
    I18nModule.forRoot({
      resources: [
        // COMMON
        { prefix: './assets/i18n/' },
        { prefix: './assets/i18n/menu/' },
        { prefix: './assets/i18n/layout/' },
        { prefix: './assets/i18n/errors/' },
        // MODALS
        { prefix: './assets/i18n/modals/complete-form/' },
        { prefix: './assets/i18n/modals/financial-health/' },
        { prefix: './assets/i18n/modals/financial-info/' },
        { prefix: './assets/i18n/modals/insurance-reasons/' },
        { prefix: './assets/i18n/modals/privacity/' },
        { prefix: './assets/i18n/modals/product-select/' },
        { prefix: './assets/i18n/modals/products/' },
        { prefix: './assets/i18n/modals/saving-goals/' },
        { prefix: './assets/i18n/modals/share/' },
        { prefix: './assets/i18n/modals/university/' },
        // PRODUCTS
        // MX
        { prefix: './assets/i18n/modals/products/contigo-inversion/' },
        { prefix: './assets/i18n/modals/products/contigo-tu-jubilacion/' },
        { prefix: './assets/i18n/modals/products/contigo-tu-retiro/' },
        { prefix: './assets/i18n/modals/products/devolucion-plus/' },
        { prefix: './assets/i18n/modals/products/plan-dotal-ahorro-mixto/' },
        { prefix: './assets/i18n/modals/products/plan-dotal-ahorro-mixto-mas/' },
        { prefix: './assets/i18n/modals/products/plan-jubilacion/' },
        { prefix: './assets/i18n/modals/products/plan-jubilacion-pl5/' },
        { prefix: './assets/i18n/modals/products/plan-jubilacion-pl10/' },
        { prefix: './assets/i18n/modals/products/plan-tiempo-seguro/' },
        { prefix: './assets/i18n/modals/products/plan-vida-entera/' },
        { prefix: './assets/i18n/modals/products/plan-vida-entera-pagos-limitados/' },
        { prefix: './assets/i18n/modals/products/plan-vida-entera-pagos-limitados-mas/' },
        { prefix: './assets/i18n/modals/products/superacion/' },
        { prefix: './assets/i18n/modals/products/superacion-plus/' },
        // BR
        { prefix: './assets/i18n/modals/products/VGBL_education/' },
        { prefix: './assets/i18n/modals/products/VGBL_goals/' },
        { prefix: './assets/i18n/modals/products/VGBL_retirement/' },
        { prefix: './assets/i18n/modals/products/MULTIFLEX_death/' },
        { prefix: './assets/i18n/modals/products/PGBL_retirement/' },
        { prefix: './assets/i18n/modals/products/BV_death/' },
        // PR
        { prefix: './assets/i18n/modals/products/convida/' },
        { prefix: './assets/i18n/modals/products/convida-tar/' },
        { prefix: './assets/i18n/modals/products/convida-oro/' },
        { prefix: './assets/i18n/modals/products/convida-oro-tar/' },
        { prefix: './assets/i18n/modals/products/fondo-universitario/' },
        { prefix: './assets/i18n/modals/products/mujer-indp/' },
        { prefix: './assets/i18n/modals/products/vivamas/' }
      ]
    }),
    NgxMaskModule.forRoot(),
    StoreModule.forRoot(appReducers, {
      metaReducers
    }),
    EffectsModule.forRoot([LifePlanEffects, RecommendedProductsEffects]),
    BuildSpecificsModules,
    RecaptchaV3Module,
    ModalsModule
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => configService.updateConfig().toPromise(),
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
